/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-tab-group.mat-tab-fill-height[_ngcontent-%COMP%]   .mat-tab-body-wrapper[_ngcontent-%COMP%]{-webkit-box-flex:1;flex:1 1 100%}"];
export { styles as styles };
